import { Configuration } from '@azure/msal-browser';

// Msal Configurations
export const msalConfig: Configuration = {
  auth: {
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AUTH_TENANT_ID}`,
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID || '',
    redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI || '',
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};
